module.exports = __webpack_public_path__ + "img/worldColour.2700x1350.3d988b25.jpg";